import {Injectable} from "@angular/core";
import {SignupStatusData} from "./signup-status.data";
import {AuthApiService} from "../auth/auth-api.service";
import {HttpClient} from "@angular/common/http";
import {firstValueFrom} from "rxjs";

@Injectable()
export class SignupService {

    constructor(private http: HttpClient, private auth: AuthApiService) {
    }

    async generateSetupUrl(venueId: string): Promise<string> {
        return firstValueFrom(this.http.get("/fonzie/customer-instance-venue/" + venueId + "/generate-setup-url", {
            headers: this.auth.getHttpHeaderOptions(),
            responseType: "text"
        }));
    }

    async getSignupStatus(token: string): Promise<SignupStatusData> {
        this.auth.signInUsingSignUpToken(token);
        return firstValueFrom(this.http.get<SignupStatusData>("/fonzie/signup", {headers: this.auth.getHttpHeaderOptions()}));

    }

    async sendSignUpUrl(venueId: string): Promise<void> {
        return firstValueFrom(this.http.post<void>("/fonzie/customer-instance-venue/" + venueId + "/send-sign-up-url", {}, {headers: this.auth.getHttpHeaderOptions()}));
    }
}
